import * as React from "react";
import Section from "../Layout/Section";
import TemplateString from "../Common/TemplateString";
import Slider from "../Common/Slider";
import SliderNavigation from "../Common/Slider/Navigation";
import SliderPagination from "../Common/Slider/Pagination";
import Media from "../Common/Media";
import * as styles from "./slider.module.css";

const SolutionSlider = ({slider}) => {
    if (!slider || !slider.items || slider.items.length === 0) {
        return null;
    }

    return (
        <Section>
            <Slider
                title={<TemplateString template={slider.title} />}
                alignLeft
                navigation={<SliderNavigation />}
                pagination={<SliderPagination />}
                sliderClassName={styles.slider}
                containerClassName={styles.slider__container}
                titleClassName={styles.slider__title}
            >
                {slider.items.map(({id, title, photo, list}) => {
                    return (
                        <div key={id} className={styles.slider__card}>
                            <div className={styles.slider__cardHeader}>
                                {photo && (
                                    <Media
                                        media={{youtubeVideoURL: "", content: photo}}
                                        className={styles.slider__cardImage}
                                    />
                                )}
                                <h3 className={styles.slider__cardName}>{title}</h3>
                            </div>
                            <ul>
                                {list.map((item) => (
                                    <li key={item.id} className={styles.slider__cardListItem}>
                                        <div>
                                            <TemplateString template={item.text} />
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    );
                })}
            </Slider>
        </Section>
    );
};

export default SolutionSlider;
